<template>
    <div class="main-page-wrap text-justify">
        <div class="main-page__logos-line">
            <a href="https://www.hse.ru/" target="_blank" class="main-page__link main-page__link--1"></a>
            <a href="https://ioe.hse.ru/" target="_blank" class="main-page__link main-page__link--2"></a>
        </div>
        <h2 class="headline text-xs-center mt-2 mb-4">{{title}}</h2>

        <slot></slot>

        <v-spacer></v-spacer>

        <div class="mt-5 text-xs-center" v-if="$slots.btn">
            <slot name="btn"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: String
        }
    }
</script>

<style lang="stylus" scoped>
    .main-page__logos-line {
        display flex
        flex-flow row nowrap
        justify-content space-between
        align-items top
        padding-bottom 1rem
    }

    .main-page__link {
        display inline-block
        text-decoration none
        width 100px
        height 100px
        background no-repeat center center / contain

        &--1 {
            background-image url(/images/hse_ru_logo.svg)
        }

        &--2 {
            background-image url(/images/ioe_logo.png)
        }
    }
</style>
